import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';
import { User } from './entities/user';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss']
})
export class AppComponent {
	public appPages = [
		{
		  title: 'USER',
		  url: '/user',
		  icon: 'person',
		  authority: false,
		  id: 'USER'
		},
		{
		  title: 'HERMANO',
		  url: '/hermano',
		  icon: 'people',
		  authority: false,
		  id: 'BROTHER'
		},
		{
		  title: 'PAGOS',
		  url: '/pago',
		  icon: 'cash',
		  authority: false,
		  id: 'PAGOS'
		},
		{
		  title: 'DEUDA',
		  url: '/deuda',
		  icon: 'business',
		  authority: false,
		  id: 'DEUDA'
		},
		{
		  title: 'INSIGNIAS',
		  url: '/insignias',
		  icon: 'list',
		  authority: true,
		  id: 'INSIGNIA'
		}
		,
		{
			title: 'PAPELETAS',
			url: '/papeletas',
			icon: 'document',
			authority: true,
			id: 'PAPELETA'
		  },
		  {
			title: 'SUGERENCIAS',
			url: '/sugerencias',
			icon: 'archive',
			authority: true,
			id: 'SUGERENCIA'
		  },
		  {
			title: 'DONATIVOS',
			url: '/donativos',
			icon: 'card',
			authority: true,
			id: 'DONATIVOS'
		  },
		/*
		{
		  title: 'MY BONUSES',
		  url: '/bonus-history',
		  icon: 'appstore',
		  authority: true,
		  id: 'BONUSES'
		},
		{
		  title: 'MY_CARS',
		  url: '/vehicle',
		  icon: 'car',
		  authority: true,
		  id: 'MY_CARS'
		},
		{
		  title: 'BOOKINGS',
		  url: '/booking',
		  icon: 'calendar',
		  authority: true,
		  id: 'BOOKINGS'
		},
		*/
		{
		  title: 'EXIT',
		  url: '/login',
		  icon: 'exit',
		  authority: true,
		  id: 'EXIT'
		}
		];
	user: User;

	constructor(
		private platform: Platform,
		private splashScreen: SplashScreen,
		private statusBar: StatusBar,
		public translate: TranslateService,
		private authServ: AuthService,
		private userServ: UserService,
		
	){
		
		this.initializeApp();
		
	}

	async initializeApp() {
		
		this.translate.setDefaultLang('es');

		this.platform.ready().then(() => {
			this.statusBar.styleDefault();
			this.splashScreen.hide();
		});
	}

	cambiaIdioma(idioma: string) {
		this.translate.use(idioma);
	}
	
	datosUser() {
		if(this.authServ.ID != undefined){
			this.userServ.getUser(this.authServ.ID).subscribe( data => {
				if(data){
					this.user = data;
				}
				
			},
			error =>  {
				console.log(error);
			});			
		}
	}


}
